import { Button } from '@teuteuf-games/button';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { AdnginEndMobile0 } from '../../components/AdnginEndMobile0';
import { useUser } from '../../providers/UserProvider';
import { getOtherMode, MatchModeConfig } from './matchConfig';
import { Tally } from './useMatchSession';

/**
 * Accuracy-only end screen. Deliberately not ModeEndScreen: that one is built
 * around score/streak/personal-best plus sharing, all of which this mode has
 * dropped, and it is still in use by Emblems. The stat chips below copy its
 * styling so the two screens still look related.
 */
export const MatchEndScreen = ({
  config,
  tally,
  onPlayAgain,
}: {
  config: MatchModeConfig;
  tally: Tally;
  onPlayAgain: () => void;
}) => {
  const { t } = useTranslation();
  const i18nBase = config.i18nBase;
  const history = useHistory();
  const { userDetails } = useUser();

  const otherMode = getOtherMode(config.key);
  const accuracy = tally.total
    ? Math.round((tally.correct / tally.total) * 100)
    : 0;

  return (
    <div className="flex flex-col w-full max-w-lg px-3 gap-5 items-center">
      <p className="mt-4 text-lg font-bold">⛳️ {t('modes.session-over')}</p>

      <div className="flex flex-col w-full py-5 gap-1 items-center justify-center rounded-2xl bg-gray-100 dark:bg-slate-700">
        <p className="text-4xl font-bold leading-none">{accuracy}%</p>
        <p className="text-sm text-gray-500 dark:text-slate-300">
          {t('modes.accuracy')}
        </p>
        <p className="mt-2 text-base font-bold">
          {t(`${i18nBase}.correct`)} {tally.correct}/{tally.total}
        </p>
      </div>

      <div className="flex flex-col w-full gap-3">
        <Button
          buttonStyle="primary"
          label={t('modes.play-again')}
          width="w-full"
          onClick={onPlayAgain}
        />
        <Button
          buttonStyle="tertiary"
          label={t('modes.try-other', { mode: t(otherMode.titleKey) })}
          width="w-full"
          onClick={() => history.push(otherMode.path)}
        />
        <Button
          buttonStyle="tertiary"
          label={t('modes.back-to-daily')}
          width="w-full"
          onClick={() => history.push('/')}
        />
      </div>

      {!userDetails?.premiumGames?.includes('flagle') && <AdnginEndMobile0 />}
    </div>
  );
};
